import { validate as validateClass, IsNotEmpty } from 'class-validator';
import hash from 'object-hash';
import { ConvoMessageItemType } from '@/store/enums/convoMessageItemType.enum';
import { AccordionItemBase } from './accordionItemBase';
import { IContentItem, IContentItemConvertible } from './interfaces';
import { ImageContentItemFactory } from './factories/imageContentItem.factory';
import { ImageAccordionItemFactory } from './factories/imageAccordionItem.factory';
import { IConvoState } from '../modules/convo-details';
import { IObservableItem } from './interfaces/observableItem.interface';
import truncateStringWithEllipsis from '@/utils/truncateStringWithEllipsis';
import { IValidatable } from './interfaces/validatable.interface';
import { getErrorMessage } from '@/store/services/validationService';

export class Image
    extends AccordionItemBase
    implements IContentItemConvertible, IObservableItem<IConvoState>, IValidatable<IConvoState>
{
    constructor(items = []) {
        super(items);
        this.type = ConvoMessageItemType.Image;
        this.icon = 'image';
        this.isDraggable = true;
        this.isDeletable = true;
    }

    @IsNotEmpty({ message: getErrorMessage('emptyAttachment', 'image') })
    image: {
        url: string;
        height: number;
        width: number;
    };

    setTitle() {
        this.subtitle = truncateStringWithEllipsis(this.image?.url, 50) || '--';
    }

    itemHasChanges(state: IConvoState): boolean {
        const contentItemFactory = new ImageContentItemFactory();
        const contentItem = contentItemFactory.make(this, state);

        contentItem.version = hash(contentItem);

        if (this.originalVersion) {
            return contentItem.version !== this.originalVersion;
        }
        return false;
    }

    toContentItem(state: IConvoState): IContentItem {
        const contentItemFactory = new ImageContentItemFactory();
        return contentItemFactory.make(this, state);
    }

    toAccordionItem(contentItem: IContentItem, isClone?: boolean): AccordionItemBase {
        const accordianItemFactory = new ImageAccordionItemFactory();
        return accordianItemFactory.make(contentItem);
    }

    async validate(state: IConvoState, path: number[]): Promise<any[]> {
        const errors = await validateClass(this);
        const errorMessages: any[] = [];

        if (errors.length > 0) {
            errors.forEach((item) => {
                errorMessages.push({
                    path,
                    errors: { [item.property]: Object.values(item.constraints || {}) },
                });
            });
        }

        return errorMessages;
    }
}
